
import { Heart, ShieldCheck, Smile } from "lucide-react";

export const FeaturesSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="p-6 border border-dental-light/20 rounded-xl hover-lift animate-fade-in">
            <div className="w-14 h-14 rounded-full bg-dental-accent/10 flex items-center justify-center mb-5">
              <Smile size={24} className="text-dental-accent" />
            </div>
            <h3 className="text-xl font-serif font-medium mb-3">Gentle Care</h3>
            <p className="text-dental-muted">We prioritize your comfort with a gentle approach to dental treatments.</p>
          </div>
          
          <div className="p-6 border border-dental-light/20 rounded-xl hover-lift animate-fade-in" style={{
            animationDelay: "0.1s"
          }}>
            <div className="w-14 h-14 rounded-full bg-dental-highlight/10 flex items-center justify-center mb-5">
              <ShieldCheck size={24} className="text-dental-highlight" />
            </div>
            <h3 className="text-xl font-serif font-medium mb-3">Modern Technology</h3>
            <p className="text-dental-muted">Advanced equipment and techniques for precise and efficient treatments.</p>
          </div>
          
          <div className="p-6 border border-dental-light/20 rounded-xl hover-lift animate-fade-in" style={{
            animationDelay: "0.2s"
          }}>
            <div className="w-14 h-14 rounded-full bg-dental-accent/10 flex items-center justify-center mb-5">
              <ShieldCheck size={24} className="text-dental-accent" />
            </div>
            <h3 className="text-xl font-serif font-medium mb-3">Experienced Team</h3>
            <p className="text-dental-muted">Our specialists bring years of expertise to every aspect of your dental care.</p>
          </div>
          
          <div className="p-6 border border-dental-light/20 rounded-xl hover-lift animate-fade-in" style={{
            animationDelay: "0.3s"
          }}>
            <div className="w-14 h-14 rounded-full bg-dental-highlight/10 flex items-center justify-center mb-5">
              <Heart size={24} className="text-dental-highlight" />
            </div>
            <h3 className="text-xl font-serif font-medium mb-3">Patient-Focused</h3>
            <p className="text-dental-muted">We build relationships based on trust, respect, and personalized care.</p>
          </div>
        </div>
      </div>
    </section>
  );
};
